import React, { useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";

function Checkout() {
    return (
        <React.Fragment></React.Fragment>
    );
}
export default Checkout;
